const messages = {
    availPoints: "Tilgjengelige poeng",
    awaitingPoints: "Ventende poeng",
  board: {
    title: "Oversikt",
    title2: "Ytelsesanimasjon {year}",
    headline1: "Kampanjene og poengene dine på et øyeblikk",
    headline2: "Tjen poeng for dine dekkkjøp.",
    pointsBalanceToDate: "POENGBALANSE PER DATO",
    availPoints: "Tilgjengelige poeng",
    awaitingPoints: "Ventende poeng",
    yourRealisation: "DINE PRESTASJONER",
    yourEngagement: "Din årlige forpliktelse: <b>{tyres} dekk</b>",
    yourPoints: "DINE POENG",
    yourRetailPurchase: "DINE DETALJKJØP",
    yourRetailPurchaseCCS: "DITT DETALJSALG",
    pointsByPurchase: "poeng generert av kjøpene dine",
    pointsByBoosters: "poeng generert av boostere",
    pointsByBSPurchase: "Poeng generert av dine Bridgestone-kjøp",
    pointsByBSPurchaseCCS:
      "Poeng generert av dine Bridgestone-dekksalg",
    remaining: "Gjenværende dekk",
    yourGoal: "Målfremgang",
    unit: "dekk",
    buttons: {
      learnMore: "Lær mer om poengene dine",
      learnMoreAboutMechanism: "Lær mer om mekanikken",
    },
    charts: {
      byBrand: "Etter merke",
      bySize: "Etter felg<br/>størrelse",
    },
    exploreResults: "Oppdag resultatene dine",
    tyreLimitInfo:
      "Et minimum utsolgt volum på 50 Bridgestone- og/eller Firestone-dekk kreves for hver Booster-kampanjeperiode",
  },
  charts: {
    byBrand: "Etter merke",
    bySize: "etter felgstørrelse",
  },

  dashboard: {
    dashboardTitle: "Dine fordeler",
    dashboardBox: {
      title: "Poengbalanse",
      description: "Dine nåværende markedsføringspoeng totalt",
      availPoints: "Tilgjengelige poeng",
      awaitingPoints: "Ventende poeng",
      lastUpdate: "Siste oppdatering",
      button: "Lær mer",
      points: "points",
    },
  },
  soldTyres: "DEKK SOLGT",
  receivedPoints: "OPPTJET POENG",
  boosterCCS: {
    personalInfo: "Personlig informasjon",
    csNumberTitle: "Vennligst spesifiser deltakerkontonummeret(e)",
    tyresTitle: "Vennligst spesifiser antall solgte dekk",
    minTyresInfo:
      "Det kreves et minimum av {tyres} Bridgestone/Firestone-dekk. Kompensasjonen gjelder kun Bridgestone-dekk.",
    tyresAmount: "Antall dekk",
    filesTitle: "Last opp salgsbeviset ditt",
    filesDescription:
      "Vennligst merk: kun salg som spesifiserer dekkfelgstørrelse vil bli vurdert.",
    addAnotherFile: "Legg til et annet dokument",
    file: "Last opp dokument",
    formatInfo:
      "Aksepterte filformater: xlsx, jpeg og pdf. Maksimal filstørrelse: 8 MB",
    confrimationMessage:
      "<b>Takk for din deltakelse!</b> <br/>Forespørselen din er mottatt og videresendt til Bridgestone-teamene for validering.<br/>Du vil motta en e-postmelding med resultatene av Booster CCS-deltakelsen.<br/>Vi sees snart på Bridgestone Plus!",
  },
  sharePointModal: {
    header: "Del poeng",
    forShare: "Poeng du vil dele",
    title: "Tittel",
  },
  notFoundFile: "Ingen valgt",
  chooseFile: "Velg fil",
};
export default {
  messages,
};
